export default {"src":"__ASTRO_ASSET_IMAGE__3f948b62__","width":68,"height":22,"format":"svg"}